import React, { useState } from 'react';
import { Star, MapPin, Clock, Phone, Mail, Tag, ChevronRight, Heart, Share2 } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { VENDOR_PRODUCT_ROUTE } from '../../../routes/web/rootRoutes';
import img from "../../../assets/img1.jpg"
const VendorManagerCard = ({ vendor }) => {
    const {id}  =  useParams('id');
    const [isLiked, setIsLiked] = useState(false);

    return (
        <Link to={VENDOR_PRODUCT_ROUTE(vendor?._id)} className=" bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300">
            <div className="relative h-40 overflow-hidden">
                <img
                    src={vendor.logo || img}
                    alt={vendor.name}
                    className="w-full h-full object-cover"
                />
                {vendor.name && (
                    <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-1 rounded-lg shadow-lg">
                        <p className="text-sm capitalize font-bold text-gray-900">{vendor.name}</p>

                    </div>
                )}
            </div>

            <div className="p-4">
                <div className="flex justify-between items-center">
                    <h3 className="text-lg font-bold capitalize text-gray-900 mb-1 truncate">
                        {vendor.name}
                    </h3>
                    <div className="flex items-center gap-1 bg-green-600 text-white px-2 py-0.5 rounded">
                        <Star size={12} fill="white" />
                        <span className="text-sm font-bold">{vendor.rating || '4.7'}</span>
                    </div>
                </div>
                <div className="flex flex-wrap gap-2 px-2 py-1 bg-green-200 rounded-sm mb-1">
                    {vendor?.corporateCodes?.map((item, index) => (
                        <span
                            key={index}
                            className="text-[11px] font-semibold bg-white px-2 py-[2px] rounded-md text-gray-900 border border-gray-300 shadow-sm"
                        >
                            {item?.code}
                        </span>
                    ))}
                </div>

                <div className="flex items-center gap-3 mb-2">

                    <div className="flex items-center gap-1 text-gray-600">
                        <Clock size={14} />
                        <span className="text-sm">{vendor.deliveryTime || '30-35 mins'}</span>
                    </div>
                </div>

                <p className="text-sm text-gray-600 mb-1">
                    {vendor.category || 'Desserts, Beverages'}
                </p>

                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-1 text-gray-600">
                        <MapPin size={14} />
                        <span className="text-sm truncate">
                            {vendor.cityId?.name || vendor.location}
                        </span>
                    </div>

                    <div className="flex items-center gap-1 text-gray-600">
                        Vendor Manager
                        <span className="text-sm bg-green-300 px-3 rounded-full py-1 truncate">
                            {vendor?.vendorManagerCount}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
};


export default VendorManagerCard;